import { TRIMBLE_BLUE_MID } from './mc-tokens';

export const MC_COMMENTS_STATES_CSS = `
  .mc-comments__empty,
  .mc-comments__loading {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 12rem;
    padding: 2rem 1rem;
    text-align: center;
  }

  .mc-comments__empty-icon {
    color: #9d9da6;
    margin-bottom: 0.75rem;
  }

  .mc-comments__attach-icon {
    color: ${TRIMBLE_BLUE_MID};
  }
`;
